var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.001,
    height: 39.502,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M51.353 20.787c0 5.683-4.446 9.871-9.902 9.871s-9.902-4.188-9.902-9.871c0-5.723 4.446-9.871 9.902-9.871s9.902 4.148 9.902 9.871zm-4.334 0c0-3.551-2.577-5.981-5.568-5.981s-5.567 2.43-5.567 5.981c0 3.516 2.577 5.981 5.567 5.981s5.568-2.47 5.568-5.981z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M72.715 20.787c0 5.683-4.446 9.871-9.902 9.871s-9.902-4.188-9.902-9.871c0-5.719 4.446-9.871 9.902-9.871s9.902 4.148 9.902 9.871zm-4.334 0c0-3.551-2.577-5.981-5.568-5.981s-5.567 2.43-5.567 5.981c0 3.516 2.576 5.981 5.567 5.981s5.568-2.47 5.568-5.981z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M93.187 11.512v17.722c0 7.29-4.299 10.267-9.381 10.267-4.784 0-7.664-3.2-8.75-5.817l3.774-1.57c.672 1.606 2.319 3.502 4.971 3.502 3.253 0 5.27-2.007 5.27-5.786v-1.42h-.152c-.97 1.198-2.84 2.244-5.198 2.244-4.935 0-9.457-4.3-9.457-9.831 0-5.572 4.522-9.907 9.457-9.907 2.354 0 4.224 1.046 5.198 2.207h.152v-1.606h4.116zm-3.81 9.31c0-3.475-2.318-6.016-5.269-6.016-2.99 0-5.496 2.54-5.496 6.017 0 3.44 2.506 5.945 5.496 5.945 2.95 0 5.27-2.505 5.27-5.945z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M99.974 1.125v28.928h-4.228V1.125z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m116.45 24.036 3.364 2.243c-1.086 1.606-3.703 4.375-8.224 4.375-5.608 0-9.796-4.335-9.796-9.871 0-5.87 4.224-9.871 9.31-9.871 5.123 0 7.628 4.076 8.447 6.28l.45 1.12-13.196 5.466c1.01 1.98 2.582 2.99 4.785 2.99 2.207 0 3.738-1.086 4.86-2.732zm-10.357-3.552 8.821-3.662c-.485-1.233-1.945-2.092-3.663-2.092-2.203 0-5.269 1.945-5.158 5.754z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M15.545 18.22V14.03h14.113c.138.73.209 1.594.209 2.528 0 3.142-.86 7.027-3.627 9.795-2.693 2.804-6.133 4.3-10.69 4.3C7.103 30.654 0 23.774 0 15.326 0 6.88 7.103 0 15.55 0c4.673 0 8.002 1.834 10.503 4.224l-2.955 2.955c-1.794-1.683-4.224-2.991-7.553-2.991-6.168 0-10.992 4.971-10.992 11.14 0 6.168 4.824 11.139 10.992 11.139 4.001 0 6.28-1.607 7.74-3.067 1.184-1.183 1.962-2.875 2.27-5.184z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/Google_Logo.6fd42d9ce68e991e21368db98a2e0d03.svg";
export { ForwardRef as ReactComponent };